/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './header'
import Menu from './menu'
import WebMarket from './sub_components/webmarket'
import Fancybook from './fancybook'
import WinnerOdds from './sub_components/winnerOddsMarket';
import Toast from './sub_components/toast'
import * as orderService from '../services/orderService'
import * as tvService from '../services/tvService'
import * as providerIframeService from '../services/providerIframeService'
import * as eventService from '../services/eventService'
import * as utilService from '../services/utilService'
import * as rebateBonusService from '../services/rebateBonusService'

import ExpoPopup from './sub_components/expoPopup';
import CricketBoard from './score_boards/cricketBoard';
import SoccerBoard from './score_boards/soccerBoard';
import TennisBoard from './score_boards/tennisBoard';
import KabaddiBoard from './score_boards/kabaddiBoard';
import ElectionBoard from './score_boards/electionBoard';
import BetSlipPopup from './sub_components/betSlipPopup';
// import marketMsg from './marketMsg.json';
import * as stringParser from '../util/string.util'
import { scoreFormatDate } from '../util/date.util'
import { FLASH_TV_URL, NANO_TV_URL, SHOW_LMT_IFRAME, SHOW_CRICKET_SCORE_IFRAME } from '../configs/commonConfigs'
import { BRANDLOGOFILENAME, SCORELOGOFILENAME } from '../configs/authSignupConfig'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import { showRebateBonus, ShowSportsBattle } from '../configs/casinoShowList';
// import socketIOClient from "socket.io-client";
// import { SOCKET_ROOT as ENDPOINT } from '../configs/api';
import GraphicScore from './score_boards/graphicScore';
import * as authUtil from "../util/auth.util";
import { calculateBetExpouser, calculateFancyMktExpouser, calculateFancyMktExpouserDemo } from '../util/expouser.util';
import SportsBattle from './sportsBattle';
import { canSeeTV } from '../util/tv.util';
// const scoreSocket = socketIOClient(ENDPOINT);
let socket = null
let oid = OPERATOR_ID.toLowerCase()
let mBets = []
let umBets = []
let formInterval
let msgInt = null
let dataUpdate = null

class Event extends Component {
    constructor(props) {
        super(props);
        this.state = {
            game: {},
            event: {},
            gameCode: "",
            selected_market: null,
            selcted_bet_option: null,
            matched_bet: [],
            unmatched_bet: [],
            selected_list: "matched",
            frontData: {},
            runners: [],
            showToast: false,
            toastMsg: "",
            toastType: "",
            loading: true,
            fancyMarkets: [],
            lineMarkets: [],
            showExpo: false,
            lineExpo: {},
            lineName: "",
            tvUrl: "",
            streamName: "",
            tvIP: "",
            tvShow: false,
            teamSequence: [],
            loadingBet: false,
            mktFeedBooks: {},
            pinnedEvents: [],
            betLimit: 20,
            betLimitMobile: 10,
            betSlipOpen: false,
            deactivatMarkets: [],
            deactivatOrders: [],
            mapped_event_id: "2048524",
            evetList: [],
            mktsList: [],
            fancyFilter: "all",
            showFancy: true,
            hideMkt: [],
            marketMsg: {},
            scoreDetail: {},
            isGraphicScore: false,
            subscribedMarkets: [],
            score_id: "",
            betPlaced: false,
            isEventUpdate: false,
            clientip: "",
            cricketScoreUrl: "",
            lmtScoreUrl: "",
            lmtTheme: "white-red-theme",
            rebateBonus: null,
            isDesktop: false,
            socketmsg: {},
            isEventActive: true,
            mobileOpenBet: false,
            url:'https://client-sb-dev.bethubs.com/',
            isNoBalence: false,
            canSeeTVCheck: false,
            canSeeTVMSG:""
        };
    }
    detectMob() {
        const toMatch = [
            "/Android/i",
            "/webOS/i",
            "/iPhone/i",
            "/iPad/i",
            "/iPod/i",
            "/BlackBerry/i",
            "/Windows Phone/i"
        ];
        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    }
    updateBook(marketId, book) {
        let feedBooks = this.state.mktFeedBooks
        feedBooks[marketId] = book
        this.state.mktFeedBooks = feedBooks
    }
    componentWillUnmount() {
        mBets = []
        this.setState({ matched_bet: [] })
        clearInterval(msgInt)
        clearInterval(dataUpdate)
        if(!!this.props.socket){
            this.props.socket.off("demo_room");
        }
    }

    checkingetzero(txt){
        return txt.toString().length === 1 ? '0' : '';
    }

    addDemoBet(bet, prfdt){
        const crdt = new Date();
        const crdtat = `${crdt.getFullYear()}-${this.checkingetzero(crdt.getMonth())}${crdt.getMonth()}-${this.checkingetzero(crdt.getDate())}${crdt.getDate()}T${this.checkingetzero(crdt.getHours())}${crdt.getHours()}:${this.checkingetzero(crdt.getMinutes())}${crdt.getMinutes()}:${this.checkingetzero(crdt.getSeconds())}${crdt.getSeconds()}Z`;
        let demoExpo = sessionStorage.getItem('demoExpo')
        let totalexpo = 0
            if(!!demoExpo && demoExpo !== 'null' && Object.keys(demoExpo).length > 0){
                demoExpo = JSON.parse(demoExpo);
                totalexpo = (Object.values(demoExpo).reduce((a,v) =>  a = a + v , 0 ))
            }
        let resdata = {
            "provider": bet?.market?.provider,
            "orderId": crdt.getTime(),
            "orderType": "LIMIT",
            "eventId": this.props.match.params.event_id,
            "marketId": bet?.marketId,
            "marketName": bet?.market?.marketName,
            "marketType": bet?.market?.marketType,
            "marketBettingType": bet?.market?.bettingType,
            "side": bet?.bet_for?.toUpperCase(),
            // "runnerId": bet.selectionId,
            // "runnerName": "Papua New Guinea",
            "price": bet?.price,
            "amount": !!bet ? parseInt(bet.bet_amount):0,
            "runnersExposure": {
                // "247649": {
                //     "runnerId": 247649,
                //     "exposure": -100,
                //     "sharingUp": -100,
                //     "sharingMe": 0,
                //     "sharingDown": 0
                // },
                // "2857977": {
                //     "runnerId": 2857977,
                //     "exposure": 8,
                //     "sharingUp": 8,
                //     "sharingMe": 0,
                //     "sharingDown": 0
                // }
            },
            "subscriber": prfdt.userId,
            "baseAmount": bet?.bet_amount,
            "createdAt": crdtat,
            "operatorId": prfdt.operatorId,
            "username": prfdt.username,
            "currency": prfdt.currency,
            "currencyConversion": prfdt.currencyConversion,
            "userId": prfdt.userId
        };
        let btexp = 0;
        if(bet?.market?.bettingType === "LINE"){
            resdata['runnerId'] = bet?.market?.metadata?.book?.runners[0][bet.bet_for][0].line
            resdata['runnerName'] = bet?.market?.metadata?.book?.runners[0][bet.bet_for][0].line
            let btarr = [];
            btarr.push(resdata);
            let betexpo = calculateFancyMktExpouserDemo(bet.market, btarr);
            btexp = betexpo.expo;
        } else {

            let betexpo = calculateBetExpouser(bet.market,bet.market.runners,bet?.bet_for?.toLowerCase(),bet.bet_amount,bet.price,true)
            bet?.market?.runners.forEach((itm)=>{
                resdata['runnersExposure'][itm.id] = {};
                resdata['runnersExposure'][itm.id]["runnerId"]= itm.id;
                resdata['runnersExposure'][itm.id]["name"]= itm.name;
                resdata['runnersExposure'][itm.id]["exposure"]= betexpo[itm.id];
                resdata['runnersExposure'][itm.id]["sharingUp"]= 0;
                resdata['runnersExposure'][itm.id]["sharingMe"]= 0;
                resdata['runnersExposure'][itm.id]["sharingDown"]=0;
            })
            resdata['runnerId'] = bet?.selectionId; //resdata['runnersExposure'][bet?.selectionId]["runnerId"];
            resdata['runnerName'] = resdata['runnersExposure'][bet?.selectionId]["name"];
            let expvlarr = Object.values(betexpo)
            btexp = Math.min(...expvlarr);
        }
        // totalexpo = totalexpo + (bet?.market?.bettingType === "LINE" ? 0 : btexp);
        totalexpo = totalexpo + btexp;
        const profData = JSON.parse(localStorage.getItem('profData'));
        let demopl = sessionStorage.getItem('demoPnL')

        let availableBal = profData.balance + totalexpo + (!!demopl ? demopl : 0);
        if(availableBal < 0){
            this.props.notify("Not Enough Balance", "error")
            this.setState({selected_market: "", selcted_bet_option: "", loadingBet: false });
            if(bet?.market?.bettingType === "LINE"){
                // demoExpo[bet?.marketId] = demoExpo[bet?.marketId] - btexp;
                // sessionStorage.setItem('demoExpo',JSON.stringify(demoExpo));
                document.getElementById('btnHdnRecalculateDemoExpo').click();
            }
        } else {
            let res={
                isSuccess: true,
                data: resdata
            }
            this.onOrderPlaced(res);
            // this.setState({ loadingBet: true },()=>{
            //     setTimeout(() => {
            //         // this.setState({ loadingBet: false },()=>{

            //         // })    
            //         this.onOrderPlaced(res);
            //     }, 3000);
            // })
        }
    }

    addBet(bet) {
        const prfdt = JSON.parse(localStorage.getItem('profData'));
        if(prfdt.role === 'DemoClient'){
            // debugger;
            this.addDemoBet(bet, prfdt);
        } else {

            this.setState({ loadingBet: true })
            bet.event_name = this.state.game.event.name
            bet.competition_Name = this.state.game.competition.name
            let betData = JSON.parse(localStorage.getItem("betForm"))
            let body = {
                marketId: bet.marketId,
                placeInstruction: {
                    orderType: "LIMIT",
                    selectionId: parseFloat(betData.selectionId),
                    side: !!bet.bet_for ? bet.bet_for.toUpperCase() : 'UNKNOWN',
                    limitOrder: {
                        size: parseFloat(parseFloat(betData.bid_amount.toString()).toFixed(2)),
                        price: parseFloat(parseFloat(betData.bid_at.toString()).toFixed(2)),
                        persistenceType: "PERSIST"
                    }
                }
            }
            if (!!betData.bid_line && betData.bid_line > 0) {
                body.placeInstruction.selectionId = betData.bid_line
            }
            if (bet.market.bettingType === "BOOKMAKER") {
                orderService.placeBMOrder(body).then((res) => { this.onOrderPlaced(res) })
            } else if (bet.market.bettingType === "LINE") {
                orderService.placeLineOrder(body).then((res) => { this.onOrderPlaced(res) })
            } else if (bet.market.bettingType === "ODDS") {
                orderService.placeOddsOrder(body).then((res) => { this.onOrderPlaced(res) })
            }
        }
        // orderService.placeOrder(body).then((res) => {
        // if (res.isSuccess !== false && !res.errors) {
        //     if (!!res.exception && !!res.exception.message) {
        //         this.props.notify(res.exception.message, "error")
        //     } else {
        //         this.props.notify("Bet Placed Successfully !", "success")
        //         if (!!res.data && Object.keys(res.data).length > 0) {
        //             this.orderPlaced(res.data)
        //         }
        //     }
        //     setTimeout(() => {
        //         this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
        //     }, bet.market.betDelay)
        // } else {
        //     this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
        //     this.props.notify(!!res.exception && !!res.exception.message ? res.exception.message : "Bet failed due to mismatch data.", "error")
        // }


        // if (res.isSuccess !== false && !res.errors) {
        //     if (!!res.exception && !!res.exception.message) {
        //         this.props.notify(res.exception.message, "error")
        //     } else if (!!res.data && Object.keys(res.data).length > 0) {
        //         this.props.notify("Bet Placed Successfully !", "success")
        //         this.orderPlaced(res.data)
        //     }
        //     else {
        //         this.props.notify("Something went wrong, please try again", "error")
        //     }

        //     setTimeout(() => {
        //         this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
        //     }, bet.market.betDelay)
        // } else {
        //     this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
        //     this.props.notify(!!res.exception && !!res.exception.message ? res.exception.message : "Bet failed due to mismatch data.", "error")
        // }


        //     if (res.isSuccess === true && !!res.data && Object.keys(res.data).length > 0) {
        //         this.props.notify("Bet Placed Successfully !", "success");
        //         this.orderPlaced(res.data);
        //     }
        //     else if (!!res.exception && !!res.exception.message) {
        //         this.props.notify(res.exception.message, "error");
        //     }
        //     else {
        //         this.props.notify("Bet failed due to mismatch data.", "error");
        //         console.error(JSON.stringify(res));
        //     }
        //     this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false });
        // })

    }
    onOrderPlaced(res) {
        if (res.isSuccess === true && !!res.data && Object.keys(res.data).length > 0) {
            this.props.notify("Bet Placed Successfully !", "success");
            this.orderPlaced(res.data);
        }
        else if (!!res.exception && !!res.exception.message) {
            this.props.notify(res.exception.message, "error");
        }
        else {
            this.props.notify("Bet failed due to mismatch data.", "error");
            console.error(JSON.stringify(res));
        }
        this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false });
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    onMessage(data) {
        data = JSON.parse(data)
        if (data["e"] === this.props.match.params.event_id) {
            this.setState({ frontData: data })
        }
    }

    async resultDeclered(type, payload) {

        let deactivatMarkets = this.state.deactivatMarkets
        let deactivatOrders = this.state.deactivatOrders
        let matchedBets = this.state.matched_bet

        if (type === "market") {
            if (!!payload && !!payload.marketId) {
                deactivatMarkets.push(payload.marketId)
            }
            matchedBets = matchedBets.filter((bet) => {
                return deactivatMarkets.indexOf(bet.marketId) === -1
            })
        }
        else if (type === "order") {

            if (!!payload && !!payload.orderId) {
                deactivatOrders.push(payload.orderId)
            }
            matchedBets = matchedBets.filter((bet) => {
                return deactivatOrders.indexOf(bet.orderId) === -1
            })
        }
        else if (type === "rollback") {

            let index = deactivatMarkets.indexOf(payload.marketId)
            if (index > -1) {
                deactivatMarkets.splice(index, 1)
            }

            eventService.getMatchedBets({ "id": this.state.evetList.toString() }).then((res) => {

                if (!!res && res.isSuccess) {
                    mBets = []
                    res.items.forEach((bet) => {
                        if (bet.marketBettingType === "LINE") {
                            bet.runnerName = bet.marketName
                        }
                        mBets.push(bet)
                    })

                    mBets = mBets.filter((bet) => {
                        return deactivatMarkets.indexOf(bet.marketId) === -1
                    })
                    mBets = mBets.filter((bet) => {
                        return deactivatOrders.indexOf(bet.orderId) === -1
                    })

                    this.setState({ matched_bet: mBets })
                }
            })

        }

        this.setState({ matched_bet: matchedBets, deactivatMarkets: deactivatMarkets, deactivatOrders: deactivatOrders })
    }
    showExpo(data, lineName) {
        this.setState({ showExpo: true, lineExpo: data, lineName: lineName })
    }
    hidePopup() {
        this.setState({ showExpo: false, betSlipOpen: false, lineExpo: {}, lineName: "" })
    }
    calc(theform) {
        var num = theform.original.value, rounded = theform.rounded
        var with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
        rounded.value = with2Decimals
    }
    text(url) {
        return fetch(url).then(res => res.text());
    }
    async getMyIp() {
        let ip = ""
        await this.text('https://www.cloudflare.com/cdn-cgi/trace').then(data => {
            data = data.split("\n")
            data.forEach((str) => {
                if (str.includes("ip=")) {
                    ip = str.split("ip=")[1]
                }
            })
        });
        return ip
    }
    async componentDidMount() {
        let selectedEvent = {}
        let teamSequence = []
        let rebateBonus = null;
        if (window.screen.width >= 768) {
            this.setState({ isDesktop: true })
        }
        const accData = this.getAccountData();
        if (showRebateBonus.show && (!!accData && Object.keys(accData).length > 0)) {
            const rebateBonusRes = await rebateBonusService.getUserRebateBonus();
            if (!!rebateBonusRes && !!rebateBonusRes.sportRebateBonus && rebateBonusRes.sportRebateBonus.length > 0) {
                rebateBonus = {};
                rebateBonusRes.sportRebateBonus.forEach((bns) => {
                    rebateBonus[bns.bettingType] = bns.amount;
                })
            }
            // this.setState({rebateBonus: rebateBonus});
        }
        let evetData = await eventService.getUserEventById(this.props.match.params.event_id)
        this.setState({isActive: evetData.isActive, loading: false})
        let events = []
        let scoreId = this.props.match.params.event_id
        // this.state.marketMsg = marketMsg
        // let msgs = await eventService.(this.props.match.params.event_id)
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if (!(!!userData && !!userData.sub)) {
            authUtil.logout();
        } else {
            this.state.accounts = userData.sub
        }

        if(!!userData && userData.role === 'DemoClient'){
            socket.on("demo_room", async (data) => {
                let msg = JSON.parse(data);
                if (!!msg.command && ["MARKET_RESULT","MARKET_VOID"].includes(msg.command)) {
                    let demoIdSsData = this.state.matched_bet;
                    let betindex = -1;
                    
                    for(let i=0; i<demoIdSsData.length;i++){
                        if(demoIdSsData[i].marketId === msg.payload.message.marketId){
                            betindex = i;
                            break;
                        }
                    } 

                    if(betindex >-1){
                        demoIdSsData.splice(betindex,1);
                        this.setState({matched_bet:demoIdSsData})
                    }

                    // msg.payload
                }
            })
        }


        let msgs = !!evetData.metadata && !!evetData.metadata.messages ? JSON.parse(evetData.metadata.messages) : {}
        let inActiveMkts = !!evetData.metadata && !!evetData.metadata.inactiveMarkets ? JSON.parse(evetData.metadata.inactiveMarkets) : []

        this.setState({ marketMsg: msgs, score_id: !!evetData.metadata && !!evetData.metadata.scoreUrl ? evetData.metadata.scoreUrl : "", matched_bet: [], rebateBonus: rebateBonus },
            () => {
                (SHOW_LMT_IFRAME && (this.props.match.params.event === "1" || this.props.match.params.event === "2")) && this.lmtScore()
            }
        )

        localStorage.removeItem("betForm");
        localStorage.removeItem("betExpo");
        if (evetData.metadata && !!evetData.metadata.score) {
            this.setState({ frontData: JSON.parse(evetData.metadata.score) })
            // scoreSocket.emit('score_room', this.props.match.params.event_id)
            // scoreSocket.on("score_room", data => {
            //     this.onMessage(data)
            // });
            // scoreSocket.on('disconnect', () => {
            //     scoreSocket.emit('score_room', this.props.match.params.event_id)
            // })
            this.setState({
                scoreDetail: {
                    evtId: scoreId,
                    type: "4"
                }
            })
        } else if (!!evetData.event && evetData.event.scoreUrl !== "" && (this.props.match.params.event === "1" || this.props.match.params.event === "2")) {
            // let data = false
            scoreId = evetData.event.scoreUrl
            this.setState({
                scoreDetail: {
                    evtId: scoreId,
                    type: this.props.match.params.event
                }
            })
        }
        if (!evetData.catalogues || evetData.catalogues.length === 0) {
            return false
        }
        let runners = evetData.catalogues.filter((mkt) => {
            return mkt.marketType === "MATCH_ODDS"
        })[0]
        if (!runners) {
            runners = evetData.catalogues.filter((mkt) => {
                return mkt.marketType === "BOOKMAKER"
            })[0]
        }
        if (!!runners) {
            runners = runners.runners
            teamSequence = runners.map((r) => { return r = r.name })
        } else {
            runners = evetData.catalogues[0].runners
        }
        this.setState({ runners: runners, teamSequence: teamSequence },
            () => {
                (SHOW_CRICKET_SCORE_IFRAME && this.props.match.params.event === "4") && this.cricketScore()
            }
        )
        selectedEvent = events.filter((e, i) => {
            return e.id === this.props.match.params.event_id
        })
        let evtList = [this.props.match.params.event_id]

        evetData.catalogues = evetData.catalogues.filter((mkt) => {
            return mkt.status !== "INACTIVE" && mkt.status !== "CLOSED" && inActiveMkts.indexOf(mkt.marketId) === -1
        })
        let mktsList = evetData.catalogues.map((evt) => { return evt = evt.marketId })
        evetData.catalogues && evetData.catalogues.forEach((market, i) => {
            if (!!evetData.metadata && !!evetData.metadata.books) {
                // let mktBook = stringParser.deSrlz(evetData.metadata.books[market.marketId])
                let mktBookData = JSON.parse(evetData.metadata.books)
                let mktBook = !!mktBookData && mktBookData[market.marketId] ? stringParser.deSrlz(mktBookData[market.marketId]) : null

                evetData.catalogues[i].metadata = {}
                evetData.catalogues[i].metadata.book = mktBook
            } else {
                let baseData = {
                    marketId: market.marketId,
                    status: "OPEN",
                    runners: []
                }
                evetData.catalogues[i].runners.forEach((rnr) => {
                    let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                    baseData.runners.push(data)
                })
                evetData.catalogues[i].metadata = {}
                evetData.catalogues[i].metadata.book = baseData
            }

        })
        evetData.catalogues = evetData.catalogues.filter((mkt) => {
            return !!mkt.metadata && !!mkt.metadata.book && (mkt.provider === "SKY" || mkt.provider === "BETFAIR" || mkt.provider === "BETHUBS")
        })
        var moPos = evetData.catalogues.findIndex(function (mkt) { return mkt.provider === "BETFAIR" && mkt.marketType === "MATCH_ODDS" });
        if (moPos !== -1) {
            let mom = [evetData.catalogues[moPos]]
            evetData.catalogues.splice(moPos, 1)
            evetData.catalogues = mom.concat(evetData.catalogues)
        }
        let fancy_mkts = evetData.catalogues.filter((mkt) => {
            return (mkt.marketType.substring(0, 3) === "SES" || mkt.bettingType === "LINE") && !!mkt.metadata && !!mkt.metadata.book && !!mkt.metadata.book.marketId && (mkt.metadata.book.status !== "CLOSED" && mkt.metadata.book.status !== "INACTIVE")
        })
        let line_mkts = []
        evetData.catalogues = evetData.catalogues.filter((mkt) => {
            return mkt.marketType.substring(0, 3) !== "SES" && mkt.bettingType !== "LINE"
        })
        fancy_mkts = fancy_mkts.sort((a, b) => a.marketId - b.marketId);
        let tvUrl = !!evetData.metadata && !!evetData.metadata.tvUrl && (!!accData && Object.keys(accData).length > 0) ? evetData.metadata.tvUrl : ""
        // if ((this.props.match.params.event === "1" || this.props.match.params.event === "2" || this.props.match.params.event === "7") && tvUrl.includes("ip=")) {
        //     let ipData = await utilService.getClientIp()
        //     tvUrl = tvUrl + ipData.IPv4
        // }
        let pinnedEvents = localStorage.getItem("pinnedEvents")
        pinnedEvents = !!pinnedEvents && (!!accData && Object.keys(accData).length > 0) ? pinnedEvents.split(",") : []
        this.setState({ pinnedEvents: pinnedEvents, game: evetData, matched_bet: mBets, unmatched_bet: umBets, gameCode: this.props.match.params.event, event: selectedEvent, loading: false, fancyMarkets: fancy_mkts, lineMarkets: line_mkts, tvUrl: tvUrl, evetList: evtList, mktsList: mktsList }, async () => {
            let self = this
            if (!!accData && Object.keys(accData).length > 0) {
                eventService.getMatchedBets({ "id": evtList.toString() }).then((res) => {
                    if (!!res && res.isSuccess) {
                        mBets = []
                        if(!!userData && userData.role === 'DemoClient'){
                            let demoIdSsData = sessionStorage.getItem('demoIdSsData');
                            demoIdSsData = !!demoIdSsData ? JSON.parse(demoIdSsData) : null;
                            if(!!demoIdSsData && !!demoIdSsData[this.props.match.params.event_id]){
                                mBets = demoIdSsData[this.props.match.params.event_id]
                            }
                        } else {
                            res.items.forEach((bet) => {
                                bet.eventName = evetData.eventName
                                if (bet.marketBettingType === "LINE") {
                                    bet.runnerName = bet.marketName
                                }
                                mBets.push(bet)
                            })
                        }
                        // mBets = mBets.reverse()
                        this.setState({ matched_bet: [] },
                            () => {
                                this.setState({ matched_bet: mBets })
                            }
                        )
                    }
                })
            }
            // msgInt = setInterval(async function mktMsg() {
            //     clearInterval(msgInt)
            //     let msgs = await eventService.getEventMktMessages(self.props.match.params.event_id)
            //     self.setState({ marketMsg: msgs }, () => {
            //         msgInt = setInterval(mktMsg, 60000)
            //     })
            // }, 60000)
            dataUpdate = setInterval(async function detaUpdater() {
                clearInterval(dataUpdate)
                // self.props.socket._callbacks["$market_room"]=[];
                evetData = await eventService.getUserEventById(self.props.match.params.event_id)
                self.setState({isActive: evetData.isActive})
                
                if (!evetData.catalogues) {
                    dataUpdate = setInterval(detaUpdater, ((!!accData && Object.keys(accData).length > 0) ? 15000 : 60000))
                    return false
                }

                let inActiveMkts = !!evetData.metadata && !!evetData.metadata.inactiveMarkets ? JSON.parse(evetData.metadata.inactiveMarkets) : []

                evetData.catalogues = !!evetData.catalogues ? evetData.catalogues.filter((mkt) => {
                    return mkt.status !== "INACTIVE" && mkt.status !== "CLOSED" && inActiveMkts.indexOf(mkt.marketId) === -1
                }) : []
                // let msgs = !!evetData.metadata && !!evetData.metadata.messages ? JSON.parse(evetData.metadata.messages) : {}
                let mktsList = evetData.catalogues.map((evt) => { return evt = evt.marketId })
                evetData.catalogues && evetData.catalogues.forEach((market, i) => {
                    if (!!evetData.metadata && !!evetData.metadata.books) {
                        // let mktBook = stringParser.deSrlz(evetData.metadata.books[market.marketId])
                        let mktBookData = JSON.parse(evetData.metadata.books)
                        let mktBook = !!mktBookData && mktBookData[market.marketId] ? stringParser.deSrlz(mktBookData[market.marketId]) : null

                        evetData.catalogues[i].metadata = {}
                        evetData.catalogues[i].metadata.book = mktBook
                    } else {
                        let baseData = {
                            marketId: market.marketId,
                            status: "OPEN",
                            runners: []
                        }
                        evetData.catalogues[i].runners.forEach((rnr) => {
                            let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                            baseData.runners.push(data)
                        })
                        evetData.catalogues[i].metadata = {}
                        evetData.catalogues[i].metadata.book = baseData
                    }
                })
                evetData.catalogues = !!evetData.catalogues ? evetData.catalogues.filter((mkt) => {
                    return !!mkt.metadata && !!mkt.metadata.book && (mkt.provider === "SKY" || mkt.provider === "BETFAIR" || (mkt.provider === "BETHUBS"))
                }) : []
                var moPos = evetData.catalogues.findIndex(function (mkt) { return mkt.provider === "BETFAIR" && mkt.marketType === "MATCH_ODDS" });
                if (moPos !== -1) {
                    let mom = [evetData.catalogues[moPos]]
                    evetData.catalogues.splice(moPos, 1)
                    evetData.catalogues = mom.concat(evetData.catalogues)
                }
                let fancy_mkts = evetData.catalogues.filter((mkt) => {
                    return (mkt.marketType.substring(0, 3) === "SES" || mkt.bettingType === "LINE") && !!mkt.metadata && !!mkt.metadata.book && !!mkt.metadata.book.marketId && (mkt.metadata.book.status !== "CLOSED" && mkt.metadata.book.status !== "INACTIVE")
                })
                evetData.catalogues = evetData.catalogues.filter((mkt) => {
                    return mkt.marketType.substring(0, 3) !== "SES" && mkt.bettingType !== "LINE"
                })
                fancy_mkts = fancy_mkts.sort((a, b) => a.marketId - b.marketId);
                // console.log("fancy_mkts",  Object.assign({}, evetData))
                // self.setState({ game: {}, isEventUpdate: true }, () => {
                self.setState({ isEventUpdate: true }, () => {
                    dataUpdate = setInterval(detaUpdater, ((!!accData && Object.keys(accData).length > 0) ? 15000 : 60000))
                    self.setState({ game: Object.assign({}, evetData), fancyMarkets: Object.assign([], fancy_mkts), mktsList: mktsList }, () => {
                        self.setState({ isEventUpdate: false })
                    })
                })
            }, ((!!accData && Object.keys(accData).length > 0) ? 15000 : 60000))
        })
    }
    componentDidUpdate() {
        // componentWillReceiveProps(){
        const self = this;
        setTimeout(() => {
            if (!!self.state.game && !!self.state.game.event && self.state.game.event.id !== self.props.match.params.event_id) {
                clearInterval(msgInt)
                clearInterval(dataUpdate)
                self.setState({
                    game: {},
                    event: {},
                    gameCode: "",
                    selected_market: null,
                    selcted_bet_option: null,
                    matched_bet: [],
                    unmatched_bet: [],
                    selected_list: "matched",
                    frontData: {},
                    runners: [],
                    showToast: false,
                    toastMsg: "",
                    toastType: "",
                    loading: false,
                    fancyMarkets: [],
                    lineMarkets: [],
                    showExpo: false,
                    lineExpo: {},
                    lineName: "",
                    tvUrl: "",
                    streamName: "",
                    tvIP: "",
                    tvShow: false,
                    teamSequence: [],
                    loadingBet: false,
                    mktFeedBooks: {},
                    pinnedEvents: [],
                    betLimit: 20,
                    betLimitMobile: 10,
                    betSlipOpen: false,
                    deactivatMarkets: [],
                    deactivatOrders: [],
                    mapped_event_id: "2048524",
                    evetList: [],
                    mktsList: [],
                    fancyFilter: "all",
                    showFancy: true,
                    hideMkt: [],
                    marketMsg: {},
                    scoreDetail: {},
                    isGraphicScore: false,
                    subscribedMarkets: [],
                    score_id: "",
                    betPlaced: false,
                    isEventUpdate: false,
                    clientip: "",
                    isNoBalence: false,
                    canSeeTVCheck: false,
                    canSeeTVMSG:""
                }, () => {
                    self.componentDidMount();
                })
            }
        }, 100);
    }
    betForm(market, bet, clicked) {
        let self = this
        if (this.state.loadingBet === true) {
            return false
        }
        if (market === null && bet === null) {
            localStorage.removeItem("betForm");
            localStorage.removeItem("betExpo");
        }
        this.setState({ selected_market: market, selcted_bet_option: bet }, () => {
            if (market !== null && bet !== null && clicked) {
                if (window.innerWidth > 767) {
                    let screenHeight = window.innerHeight
                    let myBetForm = document.getElementById("betFormBtns")? document.getElementById("betFormBtns").offsetTop : 0
                    let myBetFormPt = document.getElementById("betFormBtns")?document.getElementById("betFormBtns").parentNode.parentNode.offsetTop:0
                    if ((myBetFormPt + myBetForm) > (window.scrollY + (screenHeight / 2))) {
                        window.scrollTo(0, window.scrollY + 70)
                    }
                } else {
                    let screenHeight = window.innerHeight
                    let myBetForm = document.getElementById("betFormBtnsMob")? document.getElementById("betFormBtnsMob").offsetTop:0
                    let myBetFormPt = document.getElementById("betFormBtnsMob")? document.getElementById("betFormBtnsMob").parentNode.parentNode.offsetTop:0
                    if ((myBetFormPt + myBetForm) > (window.scrollY + (screenHeight / 2))) {
                        window.scrollTo(window.scrollY, window.scrollY + 235)
                    }
                    // document.getElementById("betFormBtnsMob").style.top = window.pageYOffset+(screenHeight/2)
                    // let yOffset = (screenHeight / 2) - window.pageYOffset + 235
                    // myBetForm = myBetForm + 235
                    // if (myBetForm < yOffset) {
                    //     window.scrollTo(0, window.scrollY + 235)
                    // } else {
                    //     window.scrollTo(0, window.scrollY)
                    // }
                }
            }
            clearTimeout(formInterval)
            formInterval = setTimeout(function intetvalBetForm() {
                if (self.state.selected_market === market && self.state.selcted_bet_option === bet) {
                    self.betForm(null, null)
                }
            }, 10000)
        })
    }
    toggleMultiMarket(eventId) {
        let pinnedEvents = localStorage.getItem("pinnedEvents")
        pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : []
        let eventIndex = pinnedEvents.indexOf(eventId)
        if (eventIndex === -1) {
            pinnedEvents.push(eventId)
        } else {
            pinnedEvents.splice(eventIndex, 1)
        }
        localStorage.setItem("pinnedEvents", pinnedEvents.toString())
        this.setState({ pinnedEvents: pinnedEvents })
    }
    toggleOpenMkt(mktId) {
        let hideMkt = this.state.hideMkt
        let mktIndex = hideMkt.indexOf(mktId)
        if (mktIndex === -1) {
            hideMkt.push(mktId)
        } else {
            hideMkt.splice(mktIndex, 1)
        }
        this.setState({ hideMkt: hideMkt })
    }
    arrayGroupByBKP(ary, attr) {
        // debugger
        let group = ary.reduce((r, a) => {
            r[a[attr]] = [...r[a[attr]] || [], a];
            return r;
        }, {});
        return group
    }
    arrayGroupBy(ary, attr) {
        let group = ary.reduce((r, a) => {
            if (a['bettingType'] === 'LINE' && a['provider'] === 'BETFAIR' && ((a[attr].indexOf('1_INNING') === 0 || a[attr].indexOf('2_INNING') === 0) && a[attr].indexOf('_OVR_LINE') > 7)) {
                const attrinnings = a[attr].indexOf('1_INNING') === 0 ? '1ST_INNINGS_RUNS' : '2ND_INNINGS_RUNS';
                r[attrinnings] = [...r[attrinnings] || [], a];
            } else if (a[attr] === "LAMBI") {
                const attrinnings = "OVERS";
                r[attrinnings] = [...r[attrinnings] || [], a];
            } else {
                r[a[attr]] = [...r[a[attr]] || [], a];
            }
            return r;
        }, {});
        return group
    }
    
    orgenizedFancy(markets) {
        if (!markets) {
            return {}
        }
        let newObj = {}

        if (!!markets["THREE_SELECTIONS"]) {
            newObj["THREE_SELECTIONS"] = markets["THREE_SELECTIONS"]
            delete markets["THREE_SELECTIONS"]
        }
        if (!!markets["1ST_INNINGS_RUNS"]) {
            newObj["1ST_INNINGS_RUNS"] = markets["1ST_INNINGS_RUNS"]
            delete markets["1ST_INNINGS_RUNS"]
        }
        if (!!markets["2ND_INNINGS_RUNS"]) {
            newObj["2ND_INNINGS_RUNS"] = markets["2ND_INNINGS_RUNS"]
            delete markets["2ND_INNINGS_RUNS"]
        }
        if (!!markets["1_INN_25_BALL_LINE"]) {
            newObj["1_INN_25_BALL_LINE"] = markets["1_INN_25_BALL_LINE"]
            delete markets["1_INN_25_BALL_LINE"]
        }
        if (!!markets["1_INN_50_BALL_LINE"]) {
            newObj["1_INN_50_BALL_LINE"] = markets["1_INN_50_BALL_LINE"]
            delete markets["1_INN_50_BALL_LINE"]
        }
        if (!!markets["1_INN_75_BALL_LINE"]) {
            newObj["1_INN_75_BALL_LINE"] = markets["1_INN_75_BALL_LINE"]
            delete markets["1_INN_75_BALL_LINE"]
        }
        if (!!markets["1_INN_100_BALL_LINE"]) {
            newObj["1_INN_100_BALL_LINE"] = markets["1_INN_100_BALL_LINE"]
            delete markets["1_INN_100_BALL_LINE"]
        }
        if (!!markets["2_INN_25_BALL_LINE"]) {
            newObj["2_INN_25_BALL_LINE"] = markets["2_INN_25_BALL_LINE"]
            delete markets["2_INN_25_BALL_LINE"]
        }
        if (!!markets["2_INN_50_BALL_LINE"]) {
            newObj["2_INN_50_BALL_LINE"] = markets["2_INN_50_BALL_LINE"]
            delete markets["2_INN_50_BALL_LINE"]
        }
        if (!!markets["2_INN_75_BALL_LINE"]) {
            newObj["2_INN_75_BALL_LINE"] = markets["2_INN_75_BALL_LINE"]
            delete markets["2_INN_75_BALL_LINE"]
        }
        if (!!markets["2_INN_100_BALL_LINE"]) {
            newObj["2_INN_100_BALL_LINE"] = markets["2_INN_100_BALL_LINE"]
            delete markets["2_INN_100_BALL_LINE"]
        }

        // if (!!markets["1_INNING_6_OVR_LINE"]) {
        //     newObj["1_INNING_6_OVR_LINE"] = markets["1_INNING_6_OVR_LINE"]
        //     delete markets["1_INNING_6_OVR_LINE"]
        // }
        // if (!!markets["1_INNING_10_OVR_LINE"]) {
        //     newObj["1_INNING_10_OVR_LINE"] = markets["1_INNING_10_OVR_LINE"]
        //     delete markets["1_INNING_10_OVR_LINE"]
        // }
        // if (!!markets["1_INNING_15_OVR_LINE"]) {
        //     newObj["1_INNING_15_OVR_LINE"] = markets["1_INNING_15_OVR_LINE"]
        //     delete markets["1_INNING_15_OVR_LINE"]
        // }
        // if (!!markets["1_INNING_20_OVR_LINE"]) {
        //     newObj["1_INNING_20_OVR_LINE"] = markets["1_INNING_20_OVR_LINE"]
        //     delete markets["1_INNING_20_OVR_LINE"]
        // }
        // if (!!markets["2_INNING_6_OVR_LINE"]) {
        //     newObj["2_INNING_6_OVR_LINE"] = markets["2_INNING_6_OVR_LINE"]
        //     delete markets["2_INNING_6_OVR_LINE"]
        // }
        // if (!!markets["2_INNING_10_OVR_LINE"]) {
        //     newObj["2_INNING_10_OVR_LINE"] = markets["2_INNING_10_OVR_LINE"]
        //     delete markets["2_INNING_10_OVR_LINE"]
        // }
        // if (!!markets["2_INNING_15_OVR_LINE"]) {
        //     newObj["2_INNING_15_OVR_LINE"] = markets["2_INNING_15_OVR_LINE"]
        //     delete markets["2_INNING_15_OVR_LINE"]
        // }
        // if (!!markets["2_INNING_20_OVR_LINE"]) {
        //     newObj["2_INNING_20_OVR_LINE"] = markets["2_INNING_20_OVR_LINE"]
        //     delete markets["2_INNING_20_OVR_LINE"]
        // }
        if (!!markets["OVERS"]) {
            if(!!newObj["OVERS"]){
                newObj["OVERS"] = [...newObj["OVERS"], ...markets["OVERS"]]
            } else {
                newObj["OVERS"] = markets["OVERS"]
            }
            delete markets["OVERS"]
        }
        if (!!markets["LAMBI"]) {
            if(!!newObj["OVERS"]){
                newObj["OVERS"] = [...newObj["OVERS"], ...markets["LAMBI"]]
            } else {
                newObj["OVERS"] = markets["LAMBI"]
            }
            delete markets["LAMBI"]
        }
        if (!!markets["SINGLE_OVER"]) {
            newObj["SINGLE_OVER"] = markets["SINGLE_OVER"]
            delete markets["SINGLE_OVER"]
        }
        if (!!markets["BATSMAN"]) {
            newObj["BATSMAN"] = markets["BATSMAN"]
            delete markets["BATSMAN"]
        }
        if (!!markets["BALL_BY_BALL"]) {
            newObj["BALL_BY_BALL"] = markets["BALL_BY_BALL"]
            delete markets["BALL_BY_BALL"]
        }
        if (!!markets["ODD_EVEN"]) {
            newObj["ODD_EVEN"] = markets["ODD_EVEN"]
            delete markets["ODD_EVEN"]
        }
        if (!!markets["OTHERS"]) {
            newObj["OTHERS"] = markets["OTHERS"]
            delete markets["OTHERS"]
        }
        newObj = { ...newObj, ...markets }
        let fancys = []
        Object.keys(newObj).forEach((type) => {
            newObj[type] = newObj[type].sort((a, b) => {
                return a.sortPriority - b.sortPriority;
            });
            fancys = fancys.concat(newObj[type])
        })
        return fancys
    }
    applyFancyFilter(flt) {
        this.setState({ fancyFilter: "" }, () => {
            this.setState({ fancyFilter: flt })
        })
    }
    fancyFilterApplyBKP(mktList) {
        let filter = this.state.fancyFilter
        if (filter !== "all") {
            mktList = mktList.filter((mkt, i) => {
                return mkt.marketType === filter
            })
        }
        return mktList
    }
    fancyFilterApply(mktList) {
        let filter = this.state.fancyFilter
        if (filter !== "all") {
            mktList = mktList.filter((mkt, i) => {
                if (filter === "1ST_INNINGS_RUNS") {
                    return ((mkt.marketType.indexOf('1_INNING') === 0 && mkt.marketType.indexOf('_OVR_LINE') > 7) || mkt.marketType === filter)
                } else if (filter === "2ND_INNINGS_RUNS") {
                    return ((mkt.marketType.indexOf('2_INNING') === 0 && mkt.marketType.indexOf('_OVR_LINE') > 7) || mkt.marketType === filter)
                } else if (filter === "OVERS") {
                    return (mkt.marketType === filter || mkt.marketType === 'LAMBI');
                } else {
                    return mkt.marketType === filter
                }
            })
        }
        return mktList
    }
    orderPlaced(ord) {
        let res = [ord]
        if (res[0].marketBettingType === "LINE" && res[0].marketName) {
            res[0].runnerName = res[0].marketName
        }
        let deactivatMarkets = this.state.deactivatMarkets
        let deactivatOrders = this.state.deactivatOrders
        let data = res.concat(this.state.matched_bet)
        data = data.filter((bet) => {
            return deactivatMarkets.indexOf(bet.marketId) === -1
        })
        data = data.filter((bet) => {
            return deactivatOrders.indexOf(bet.orderId) === -1
        })
        const prfdt = JSON.parse(localStorage.getItem('profData'));
        if(!!prfdt && prfdt.role === 'DemoClient'){
            let demoIdSsData = sessionStorage.getItem('demoIdSsData');
            demoIdSsData = !!demoIdSsData ? JSON.parse(demoIdSsData) : {};
            demoIdSsData[this.props.match.params.event_id] = data
            sessionStorage.setItem('demoIdSsData', JSON.stringify(demoIdSsData));
            setTimeout(()=>{
                document.getElementById('btnHdnRecalculateDemoExpo').click();
            },1000)
        }
        this.setState({ matched_bet: data, betPlaced: true })
    }
    updateXScore(data) {
        let ftdata = this.state.frontData
        Object.keys(data).forEach((key) => {
            if (key === "ps" && !!data.ps && !!data.ps.TN && this.props.match.params.event === "1") {
                Object.keys(data.ps.TN).forEach((k) => {
                    if (!ftdata.ps) {
                        ftdata.ps = {
                            TN: {}
                        }
                    }
                    ftdata.ps.TN[k] = data.ps.TN[k]
                })
            } else if (key === "ps" && this.props.match.params.event === "2") {
                Object.keys(data.ps).forEach((k) => {
                    ftdata.ps[k] = data.ps[k]
                })
            } else {
                if (key === "dr" && !!ftdata.dr && !!data.dr && ftdata.dr.s !== data.dr.s) {
                    ftdata.lastUpdated = new Date()
                }
                ftdata[key] = data[key]
            }
        })
        this.setState({ frontData: {} }, () => {
            this.setState({ frontData: ftdata })
        })
    }
    updateSubscribedMarkets(mkt) {
        let mktList = this.state.subscribedMarkets
        mktList.push(mkt)
        this.setState({ subscribedMarkets: mktList })
    }
    updateSocket(skt) {
        socket = skt
    }

    sortGameCatalogues(catArray) {
        let mktArray = catArray
        mktArray = mktArray.sort((a, b) => a.sortPriority - b.sortPriority);
        return mktArray;
    }

    getAccountData() {
        let data = localStorage.getItem("accountData")
        data = JSON.parse(data)
        return data
    }

    async liveTvToggle() {
        let winnereventdic = localStorage.getItem("winnereventdic");
        if (!!winnereventdic) {
            winnereventdic = JSON.parse(winnereventdic);
        }
        const self = this
        let accountData = this.getAccountData()
        let profData = localStorage.getItem('profData');
        if(!!profData){
            profData = JSON.parse(profData);
        }
        let chips = !!accountData ? (parseFloat(accountData.exposure) + parseFloat(accountData.balance) + parseFloat(accountData.pnl)) : 0
        // if (parseFloat(chips) <= 0) {
        //     self.setState({ tvShow: !self.state.tvShow, isNoBalence: true })
        //     return false
        // } else {
        //     self.setState({ isNoBalence: false })
        // }
        if(winnereventdic?.tvcon?.show){

            if(winnereventdic?.tvcon?.userDaysThreshholdCheck){
                let userDaysThreshholdChk = canSeeTV(winnereventdic?.tvcon?.userDaysThreshhold, profData?.createdAt)
                if (userDaysThreshholdChk) {
                    self.setState({ canSeeTVCheck: true, canSeeTVMSG: "" });
                } else {
                    self.setState({ tvShow: !self.state.tvShow, canSeeTVCheck: false, canSeeTVMSG: winnereventdic?.tvcon?.userDaysThreshholdMsg})
                    return false
                }
            }
        
            if(winnereventdic?.tvcon?.balanceThreshholdCheck){
                if ((parseFloat(accountData.exposure) < 0) || ((parseFloat(accountData.balance) + parseFloat(accountData.pnl)) > winnereventdic?.tvcon?.balanceThreshhold) ) {
                    self.setState({ canSeeTVCheck: true, canSeeTVMSG: "" });
                } else {
                    self.setState({ tvShow: !self.state.tvShow, canSeeTVCheck: false, canSeeTVMSG: winnereventdic?.tvcon?.balanceThreshholdMsg})
                    return false
                }
            }
            if (!this.state.tvShow && this.state.tvIP === "" && (this.props.match.params.event === "1" || this.props.match.params.event === "2" || this.props.match.params.event === "7") && this.state.tvUrl.includes("ip=")) {
                let client_ip = await this.getMyIp()
                let tvUrl = self.state.tvUrl + client_ip
                self.setState({ tvShow: !self.state.tvShow, tvUrl: tvUrl, tvIP: client_ip })

                // utilService.getIpdata().then((res) => {
                //     if (!!res && !!res.ip) {
                //         let tvUrl = self.state.tvUrl + res.ip
                //         self.setState({ tvShow: !self.state.tvShow, tvUrl: tvUrl, tvIP: res.ip })
                //     }
                //     else {
                //         self.setState({ tvShow: !self.state.tvShow })
                //     }
                // }).catch(error => {
                //     self.setState({ tvShow: !self.state.tvShow })
                // });
            } else {
                // if(!this.state.tvShow && !this.state.tvUrl.includes("http")){
                if (!this.state.tvShow && this.state.tvUrl.includes(NANO_TV_URL)) {
                    providerIframeService.tvNanoTempToken({ url: this.state.tvUrl }).then((res) => {
                        this.setState({ streamName: res.url, tvShow: !this.state.tvShow })
                    })
                }
                else if (!this.state.tvShow && this.state.tvUrl.includes(FLASH_TV_URL)) {
                    providerIframeService.tvFlashTempToken({ url: this.state.tvUrl }).then((res) => {
                        this.setState({ streamName: res.url, tvShow: !this.state.tvShow })
                    })
                }
                else {
                    this.setState({ tvShow: !this.state.tvShow })
                }
            }
        }
    }

    cricketScore() {
        if (!!localStorage.getItem("userAuthDetail")) {
            let body = {
                eventId: this.props.match.params.event_id,
                token: JSON.parse(localStorage.getItem("userAuthDetail")).token,
                runners: this.state.runners,
                score: this.state.frontData,
                waterMark: ['rdr', '1xb'].includes(oid) ? "1XBook" : document.title.split("-")[0].trim(),
                message: { logoUrl: `${BASE_IMAGE_PATH}/scoreimg/${oid}/${SCORELOGOFILENAME}` },
            }

            const accData = this.getAccountData();
            const prfdt = JSON.parse(localStorage.getItem('profData'));
            if ((!!accData && Object.keys(accData).length > 0) && (!!prfdt && prfdt.role !== "DemoClient")) {
                providerIframeService.cricketScoreTempToken(body).then((res) => {
                    this.setState({ cricketScoreUrl: res.url },
                        () => {
                            if(!!document.getElementById("cricket_score_iframe")){
                                document.getElementById("cricket_score_iframe").style.height = "0px"
                            }
                        }
                    )
                    window.addEventListener('message', function (event) {
                        if (event.origin === res.url.split("?")[0]) {
                            if(!!document.getElementById("cricket_score_iframe")){
                                document.getElementById("cricket_score_iframe").style.height = event.data + "px"
                            }
                        }
                    });
                })
            }
        }
    }

    lmtScore() {
        if (!!this.state.score_id) {
            let body = {
                eventId: this.props.match.params.event_id,
                scoreId: this.state.score_id,
                style: this.state.lmtTheme,
                logoUrl: `${BASE_IMAGE_PATH}/${oid}/uimg/${BRANDLOGOFILENAME}`
            }
            const accData = this.getAccountData();
            const prfdt = JSON.parse(localStorage.getItem('profData'));
            if ((!!accData && Object.keys(accData).length > 0) && (!!prfdt && prfdt.role !== "DemoClient")) {
                providerIframeService.lmtScoreTempToken(body).then((res) => {
                    this.setState({ lmtScoreUrl: res.url },
                        () => {
                            if(!!document.getElementById("soccer_tennis_score_iframe")){
                                document.getElementById("soccer_tennis_score_iframe").style.height = "0px"
                            }
                        }
                    )
                    window.addEventListener('message', function (event) {
                        if (event.origin === res.url.split("?")[0]) {
                           if(!!document.getElementById("soccer_tennis_score_iframe")){
                                document.getElementById("soccer_tennis_score_iframe").style.height = event.data + "px"
                           }
                        }
                    });
                })
            }
        }
    }
    
    updateMktMsg(marketId, msg){
        let msgs = this.state.marketMsg;
        if(msgs[marketId]){
            msgs[marketId].push(msg);
        }else{
            msgs[marketId] = [msg]
        }
        this.setState({marketMsg: msgs})
    }

    onMobileOpenBetClick(st){
        this.setState({mobileOpenBet: st});
    }

    render() {
        let fancyMarkets = this.arrayGroupBy(this.state.fancyMarkets, "marketType")
        fancyMarkets = this.orgenizedFancy(fancyMarkets)
        let fmkt = this.arrayGroupBy(fancyMarkets, "marketType")
        let maketTypeList = Object.keys(fmkt).map((fnc, i) => { return fnc = { mkt: fnc, count: fmkt[fnc].length } })
        fancyMarkets = this.fancyFilterApply(fancyMarkets)
        let bet_list = this.state.matched_bet
        let gameCatalogues = !!this.state.game.catalogues ? this.sortGameCatalogues(this.state.game.catalogues) : []
        const accData = this.getAccountData();
        const prfdt = JSON.parse(localStorage.getItem('profData'));
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} updateBetplaceStatus={() => { this.setState({ betPlaced: false }) }} betPlaced={this.state.betPlaced} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateSocket={(skt) => { this.updateSocket(skt) }} onMessage={(data) => { this.onMessage(data) }} updateXScore={(data) => { this.updateXScore(data) }} scoreData={this.state.scoreDetail} orderPlaced={(ord) => { this.orderPlaced(ord) }} resultDeclered={(type, payload) => { this.resultDeclered(type, payload) }} />
                <div className={`full-wrap mar-top100 footerpd footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} />
                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                    <div className="col-centersdetails markets">
                        {!this.state.isActive && !this.state.loading && <>
                            <div style={{width: '100%', gap:'20px',  padding:'20px', background:'white', display:'flex', flexDirection:'column', marginTop:'5px', borderRadius:'5px', justifyContent:'center', alignItems: 'center'}}>
                                <img style={{width:180}} src={require('../images/timeout.png')} />
                                <h3 style={{color:'black'}}>This event is no longer available.</h3>
                            </div>
                        </>}
                        <div className="">
                            {(["1", "2", "4", "400", "500"].includes(this.state.gameCode)) &&
                                <div className="sub_path center-box crname">
                                    <p>
                                        {!!this.state.game && !!this.state.game.event && !!this.state.game.competition && <><span>{!!this.state.game && !!this.state.game.event["name"] ? this.state.game.event["name"] : null} - {!!this.state.game && !!this.state.game.competition["name"] ? this.state.game.competition["name"] : null}</span> <span className="f-right">{scoreFormatDate(this.state.game.event["openDate"])}</span></>}
                                    </p>
                                </div>
                            }
                            <div className="livetv mt-1">
                                {!!this.state.tvUrl && this.state.tvUrl !== "" && (!!prfdt && prfdt.role !== "DemoClient") && <>
                                    <div className="sub_path center-box crname">
                                        <p>
                                            <span>Live TV</span>
                                            <div className="custom-control custom-switch float-right" style={{ display: "inline" }} onClick={() => { this.liveTvToggle() }}>
                                                <input type="checkbox" className="custom-control-input" checked={this.state.tvShow} />
                                                <label className="custom-control-label" for="customSwitches"></label>
                                            </div>
                                        </p>
                                    </div>
                                    <div className="game-wrap col3 mb-0 pb-0">
                                        {!!this.state.tvShow && !this.state.isDesktop && <div className="mobiletviframe">
                                            {!(!!this.state.canSeeTVMSG) && this.state.canSeeTVCheck ? <iframe title={"iframe"} key={"iframe"} id='fp_embed_player' src={!!this.state.streamName ? this.state.streamName : this.state.tvUrl} marginWidth='0' marginHeight='0' frameBorder='0' width='100%' height='100%' scrolling='no' allowFullScreen='allowfullscreen'></iframe> :
                                                <div className='no-balence'>{this.state.canSeeTVMSG}</div>
                                            }
                                        </div>}
                                    </div>
                                </>
                                }
                            </div>
                            {SHOW_CRICKET_SCORE_IFRAME && (!!accData && Object.keys(accData).length > 0) && (!!prfdt && prfdt.role !== "DemoClient") && this.state.gameCode === "4" && !!this.state.cricketScoreUrl && <>
                                <div>
                                    <iframe title={"Score"} key={"iframe_mob_cri"} id='cricket_score_iframe' src={!!this.state.cricketScoreUrl ? this.state.cricketScoreUrl : ""} marginWidth='0' marginHeight='0' frameBorder='0' width='100%' scrolling='no' allowFullScreen='allowfullscreen'></iframe>
                                </div>
                            </>}
                            {SHOW_LMT_IFRAME && (!!accData && Object.keys(accData).length > 0) && (!!prfdt && prfdt.role !== "DemoClient") && (this.state.gameCode === "1" || this.state.gameCode === "2") && !!this.state.lmtScoreUrl &&
                                <div>
                                    {/* Do not remove below 7 lines without Jigar Sheth Permission */}
                                    {/* <div className="">
                                        Change Theme
                                        <button type="button" className="btn btn-danger btn-circle ml-3" onClick={()=>{this.setState({lmtTheme: "white-red-theme"},()=>{this.lmtScore()})}}></button>
                                        <button type="button" className="btn btn-primary btn-circle ml-2" onClick={()=>{this.setState({lmtTheme: "blue-theme"},()=>{this.lmtScore()})}}></button>
                                        <button type="button" className="btn btn-warning btn-circle ml-2" onClick={()=>{this.setState({lmtTheme: "white-yellow-theme"},()=>{this.lmtScore()})}}></button>
                                        <button type="button" className="btn btn-dark btn-circle ml-2" onClick={()=>{this.setState({lmtTheme: "black-theme"},()=>{this.lmtScore()})}}></button>
                                    </div> */}
                                    <iframe title={"Score"} key={"iframe_mob_soc"} id='soccer_tennis_score_iframe' src={!!this.state.lmtScoreUrl ? this.state.lmtScoreUrl : ""} marginWidth='0' marginHeight='0' frameBorder='0' width='100%' scrolling='no' allowFullScreen='allowfullscreen'></iframe>
                                </div>
                            }

                            {!SHOW_CRICKET_SCORE_IFRAME && (!!accData && Object.keys(accData).length > 0) && this.state.gameCode === "4" && <CricketBoard isNoBalence={this.state.isNoBalence} tvUrl={!!this.state.streamName ? this.state.streamName : this.state.tvUrl} onOffTv={() => { this.liveTvToggle() }} tvShow={this.state.tvShow} game={this.state.game} frontData={this.state.frontData} runners={this.state.runners} />}
                            {/* {this.state.gameCode === "1" && <SoccerBoard isNoBalence={this.state.isNoBalence} tvUrl={!!this.state.streamName ? this.state.streamName : this.state.tvUrl} onOffTv={() => { this.liveTvToggle() }} tvShow={this.state.tvShow} game={this.state.game} frontData={this.state.frontData} runners={this.state.runners} />} */}
                            {/* {this.state.gameCode === "2" && <TennisBoard isNoBalence={this.state.isNoBalence} tvUrl={!!this.state.streamName ? this.state.streamName : this.state.tvUrl} onOffTv={() => { this.liveTvToggle() }} tvShow={this.state.tvShow} game={this.state.game} frontData={this.state.frontData} runners={this.state.runners} />} */}
                            {/* {this.state.gameCode === "400" && <KabaddiBoard isNoBalence={this.state.isNoBalence} tvUrl={!!this.state.streamName ? this.state.streamName : this.state.tvUrl} onOffTv={() => { this.liveTvToggle() }} tvShow={this.state.tvShow} game={this.state.game} frontData={this.state.frontData} runners={this.state.runners} />}
                            {this.state.gameCode === "500" && <ElectionBoard isNoBalence={this.state.isNoBalence} tvUrl={!!this.state.streamName ? this.state.streamName : this.state.tvUrl} onOffTv={() => { this.liveTvToggle() }} tvShow={this.state.tvShow} game={this.state.game} frontData={this.state.frontData} runners={this.state.runners} />} */}

                            {!SHOW_LMT_IFRAME && (!!accData && Object.keys(accData).length > 0) && (this.state.gameCode === "1" || this.state.gameCode === "2") && <>
                                <div>
                                    {this.state.gameCode === "1" ? <GraphicScore eventType={"footballlive"} scoreclassNameName={!!this.state.isGraphicScore ? "scoreboard-show" : "scoreboard-hide"} event_id={this.props.match.params.event_id} score_id={!!this.state.score_id ? this.state.score_id : ""} />
                                        : this.state.gameCode === "2" ? <GraphicScore eventType={"tenniscourtview"} scoreclassNameName={!!this.state.isGraphicScore ? "scoreboard-show" : "scoreboard-hide"} event_id={this.props.match.params.event_id} score_id={!!this.state.score_id ? this.state.score_id : ""} />
                                            : null
                                    }
                                </div>
                            </>
                            }
                            {/* MOBILE matched_bet_box START */}
                            <div className='matched_bet_box'>
                                <div className={`match_info_name ${!this.state.mobileOpenBet? 'active' : ''}`} onClick={()=>this.onMobileOpenBetClick(false)}>
                                    <span className='market-2'>Market</span>
                                    <div className="market market-1"></div>
                                </div>
                                <div className={`match_info_name ${this.state.mobileOpenBet? 'active' : ''}`} onClick={()=>this.onMobileOpenBetClick(true)}>
                                    <span className='market-2'>Open Bets <span className='betcount'>({!!bet_list ? bet_list.length : 0})</span></span>
                                    <div className="market market-1"></div>
                                </div>                       
                            </div>
                            {this.state.mobileOpenBet && 
                                <div className='mybet-alldata bg-white table-responsive matched_bet_box_data'>
                                    <table className="table table-bordered nowrap table-sm font-12 mb-0">
                                        <thead>
                                            <tr className="bg-dark text-white">
                                                <th>Matched Bet</th>
                                                <th>Odds</th>
                                                <th>Stake</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {!!bet_list && bet_list.length > 0 ? 
                                            bet_list.map((bet, i) => {
                                                    return (
                                                        <>
                                                            {i < this.state.betLimitMobile && 
                                                            <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                                <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                                <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                                <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                            </tr>}
                                                        </>
                                                    )
                                                })
                                                :
                                                <tr>
                                                    <td className='text-center text-danger' colSpan={3}>No bets found</td>
                                                </tr>
                                            }
                                            {/* <tr className="back-bg">
                                                <td>ODD - 1st Inning 19 Over Total ODD EVEN ADV.</td>
                                                <td>1.98</td>
                                                <td>100.00</td>
                                            </tr>
                                            <tr className="lay-bg">
                                                <td>Match 1st Over ADV. (120)</td>
                                                <td>8</td>
                                                <td>100.00</td>
                                            </tr> */}
                                        </tbody>
                                    </table>
                                </div>
                            }
                             {/* MOBILE matched_bet_box END */}
                            <div>
                                {
                                    ((!!accData && Object.keys(accData).length > 0) ? socket !== null : true) && gameCatalogues.map((market, i) => {
                                        if (market.marketType === "TIED_MATCH" || market.marketType === "COMPLETED_MATCH" || market.marketType === "WINNING_ODDS") {
                                            return false
                                        }
                                        let isMsg = !!this.state.marketMsg && !!this.state.marketMsg[market.marketId] ? this.state.marketMsg[market.marketId] : []
                                        return <WebMarket isEventUpdate={this.state.isEventUpdate} key={market.marketId} updateMktMsg = {(msg)=>{this.updateMktMsg(market.marketId, msg)}} isRebateBonus={market.bettingType === 'BOOKMAKER' && market.provider === 'BETHUBS' && market.bettingType === 'BOOKMAKER' && !!this.state.rebateBonus && !!this.state.rebateBonus[market.bettingType] && market.marketType === 'BOOKMAKER'} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} toggleOpenMkt={(mkt) => { this.toggleOpenMkt(mkt) }} hideMkt={this.state.hideMkt} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} teamSequence={this.state.teamSequence} socket={socket} curBets={bet_list} notify={(msg, type) => { this.props.notify(msg, type) }} market={market} addBet={(bet) => { this.addBet(bet) }} selected_market={this.state.selected_market} selcted_bet_option={this.state.selcted_bet_option} msgMarket={isMsg.length > 0 ? isMsg[isMsg.length - 1].message : ""} betForm={(market, bet, clicked) => { this.betForm(market, bet, clicked) }} toggleMultiMarket={(marketId) => { this.toggleMultiMarket(marketId) }} pinnedEvents={this.state.pinnedEvents} togglebetLoader={()=>this.setState({loadingBet: true})}/>
                                    })
                                }
                            </div>
                            <div className="mt-2_5">
                                {((!!accData && Object.keys(accData).length > 0) ? socket !== null : true) && (this.state.fancyMarkets.length > 0 || (ShowSportsBattle && !(!this.state.isActive && !this.state.loading))) && <div className={"live-match"}>
                                    <div className="fancybtn-new">
                                        <a><span className="font-weight-bold">Fancy</span> {this.state.fancyFilter !== "SportsBattle" ? <>{this.state.showFancy ? <i onClick={() => { this.setState({ showFancy: !this.state.showFancy }) }} className="fa fa-minus fancyplusminusmob pl-4 " aria-hidden="true"></i> : <i onClick={() => { this.setState({ showFancy: !this.state.showFancy }) }} className="fa fa-plus fancyplusminusmob pl-4" aria-hidden="true"></i>}</>:<span></span>} </a>
                                    </div>
                                    <div className="sub_path center-box fancybg">
                                        <ul className="fancy-filter">
                                            {this.state.fancyMarkets.length > 0 && <li><a onClick={() => { this.applyFancyFilter("all") }} className={this.state.fancyFilter === "all" ? "active" : null}>All</a></li>}
                                            {this.state.fancyMarkets.length > 0 && maketTypeList.map((mktTyp, i) => {
                                                if(mktTyp.mkt === "LAMBI"){
                                                    return false
                                                }
                                                return (
                                                    <li><a onClick={() => { this.applyFancyFilter(mktTyp.mkt) }} className={this.state.fancyFilter === mktTyp.mkt ? "active" : null}><span className="fancynew-budge">{mktTyp.count}</span>{mktTyp.mkt.split("_").join(" ")}</a></li>
                                                )
                                            })}
                                            {ShowSportsBattle && 
                                                <li>
                                                    <a onClick={() => { this.applyFancyFilter("SportsBattle") }} className={this.state.fancyFilter === "SportsBattle" ? "active" : null}>
                                                    {/* <span className="fancynew-budge">{mktTyp.count}</span> */}
                                                    SportsBattle</a>
                                                </li>
                                            }
                                        </ul>
                                        <span className="fancyplus-icon" style={{ color: "white" }}><a onClick={() => { this.setState({ showFancy: !this.state.showFancy }) }}>{this.state.fancyFilter !== "SportsBattle" ? <>{this.state.showFancy ? <i className="fa fa-minus" aria-hidden="true"></i> : <i className="fa fa-plus" aria-hidden="true"></i>}</>:<span></span>}</a></span>
                                    </div>
                                    <div className="fancybgmobile">
                                        <div className=" fancyscrollmenu" >
                                            <a onClick={() => { this.applyFancyFilter("all") }} className={this.state.fancyFilter === "all" ? "active" : null}>All</a>
                                            {this.state.fancyMarkets.length > 0 && maketTypeList.map((mktTyp, i) => {
                                                if(mktTyp.mkt === "LAMBI"){
                                                    return false
                                                }
                                                return (
                                                    <a onClick={() => { this.applyFancyFilter(mktTyp.mkt) }} className={this.state.fancyFilter === mktTyp.mkt ? "active" : null}>{mktTyp.mkt.split("_").join(" ")}<span className="fancynew-budge">{mktTyp.count}</span></a>
                                                )
                                            })}
                                            
                                            {ShowSportsBattle && 
                                                <li>
                                                    <a onClick={() => { this.applyFancyFilter("SportsBattle") }} className={this.state.fancyFilter === "SportsBattle" ? "active" : null}>
                                                    {/* <span className="fancynew-budge">{mktTyp.count}</span> */}
                                                    SportsBattle</a>
                                                </li>
                                            }
                                        </div>
                                    </div>
                                    {this.state.fancyFilter === "SportsBattle" ?
                                        <div style={{ display: "block"}} className="game-wrap col3">
                                            <SportsBattle eventId={this.props.match.params.event_id}></SportsBattle>
                                        </div>
                                    :
                                        <div style={{ display: this.state.showFancy ? "block" : "none" }} className="game-wrap col3">
                                            <table className="table w-100 game-list-col fancytable mb-0">
                                                <tbody>
                                                    <tr className="bet-all-new">
                                                        <td className="pb-0">&nbsp;</td>
                                                        <td className="w-16 pb-0">
                                                            <div>
                                                                <div className="">
                                                                    <a id="btnBack" className="btn-back bg-trans" side="Back">
                                                                        <span>No</span>
                                                                    </a>
                                                                </div>
                                                                <div>
                                                                    <a id="btnLay" className="btn-lay bg-trans" side="Lay">
                                                                        <span>Yes</span>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="w-16 mobile-hide pb-0"> &nbsp; </td>
                                                    </tr>
                                                    {
                                                        fancyMarkets.map((mkt, i) => {
                                                            let isMsg = !!this.state.marketMsg && !!this.state.marketMsg[mkt.marketId] ? this.state.marketMsg[mkt.marketId] : []
                                                            return <Fancybook key={mkt.marketId} updateMktMsg = {(msg)=>{this.updateMktMsg(mkt.marketId, msg)}} isRebateBonus={mkt.bettingType === 'LINE' && !!this.state.rebateBonus && !!this.state.rebateBonus[mkt.bettingType] && mkt.provider === 'BETHUBS' && mkt.marketType === 'OVERS'} isEventUpdate={this.state.isEventUpdate} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} socket={socket} showExpo={(data, lineName) => { this.showExpo(data, lineName) }} curBets={bet_list} index={i} type={"ses"} notify={(msg, type) => { this.props.notify(msg, type) }} addBet={(bet) => { this.addBet(bet) }} selected_market={this.state.selected_market} selcted_bet_option={this.state.selcted_bet_option} msgMarket={isMsg.length > 0 ? isMsg[isMsg.length - 1].message : ""} betForm={(market, bet, clicked) => { this.betForm(market, bet, clicked) }} market={mkt} toggleMultiMarket={(marketId) => { this.toggleMultiMarket(marketId) }} pinnedEvents={this.state.pinnedEvents} togglebetLoader={()=>this.setState({loadingBet: true})} />
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    }
                                </div>}
                            </div>
                            {/* Winning Odds */}
                            <div>
                                {
                                    ((!!accData && Object.keys(accData).length > 0) ? socket !== null : true) && gameCatalogues.map((market, i) => {
                                        if (market.marketType !== "WINNING_ODDS") {
                                            return false
                                        }
                                        let isMsg = !!this.state.marketMsg && !!this.state.marketMsg[market.marketId] ? this.state.marketMsg[market.marketId] : []
                                        return <WinnerOdds isEventUpdate={this.state.isEventUpdate} key={market.marketId}  showExpo={(data, lineName) => { this.showExpo(data, lineName) }} updateMktMsg = {(msg)=>{this.updateMktMsg(market.marketId, msg)}} isRebateBonus={market.bettingType === 'BOOKMAKER' && market.provider === 'BETHUBS' && !!this.state.rebateBonus && !!this.state.rebateBonus[market.bettingType] && market.marketType === 'BOOKMAKER'} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} toggleOpenMkt={(mkt) => { this.toggleOpenMkt(mkt) }} hideMkt={this.state.hideMkt} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} teamSequence={this.state.teamSequence} socket={socket} curBets={bet_list} notify={(msg, type) => { this.props.notify(msg, type) }} market={market} addBet={(bet) => { this.addBet(bet) }} selected_market={this.state.selected_market} selcted_bet_option={this.state.selcted_bet_option} msgMarket={isMsg.length > 0 ? isMsg[isMsg.length - 1].message : ""} betForm={(market, bet, clicked) => { this.betForm(market, bet, clicked) }} toggleMultiMarket={(marketId) => { this.toggleMultiMarket(marketId) }} pinnedEvents={this.state.pinnedEvents} togglebetLoader={()=>this.setState({loadingBet: true})} />
                                    })
                                }
                            </div>
                            {/* Tied and Completed match markets */}
                            <div>
                                {
                                    ((!!accData && Object.keys(accData).length > 0) ? socket !== null : true) && gameCatalogues.map((market, i) => {
                                        if (market.marketType !== "TIED_MATCH" && market.marketType !== "COMPLETED_MATCH") {
                                            return false
                                        }
                                        let isMsg = !!this.state.marketMsg && !!this.state.marketMsg[market.marketId] ? this.state.marketMsg[market.marketId] : []
                                        return <WebMarket isEventUpdate={this.state.isEventUpdate} key={market.marketId}  updateMktMsg = {(msg)=>{this.updateMktMsg(market.marketId, msg)}} isRebateBonus={market.bettingType === 'BOOKMAKER' && market.provider === 'BETHUBS' && !!this.state.rebateBonus && !!this.state.rebateBonus[market.bettingType] && market.marketType === 'BOOKMAKER'} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(mkt) => { this.updateSubscribedMarkets(mkt) }} toggleOpenMkt={(mkt) => { this.toggleOpenMkt(mkt) }} hideMkt={this.state.hideMkt} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} teamSequence={this.state.teamSequence} socket={socket} curBets={bet_list} notify={(msg, type) => { this.props.notify(msg, type) }} market={market} addBet={(bet) => { this.addBet(bet) }} selected_market={this.state.selected_market} selcted_bet_option={this.state.selcted_bet_option} msgMarket={isMsg.length > 0 ? isMsg[isMsg.length - 1].message : ""} betForm={(market, bet, clicked) => { this.betForm(market, bet, clicked) }} toggleMultiMarket={(marketId) => { this.toggleMultiMarket(marketId) }} pinnedEvents={this.state.pinnedEvents} togglebetLoader={()=>this.setState({loadingBet: true})} />
                                    })
                                }
                            </div>
                            <div className="live-match livetv">
                                {/* <div className="center-box mt-1">
                                    <div className="container-fluid titbg">
                                        <div className="w-100 float-left">
                                            <span onClick={() => { this.setState({ selected_list: "matched" }) }} className={this.state.selected_list === "matched" ? "betslip-btn active" : "betslip-btn"}>Matched Bet</span>
                                            {bet_list.length > this.state.betLimitMobile && <a className="view-more-btn" onClick={() => { this.setState({ betSlipOpen: true }) }} data-toggle="modal" data-target="#mystatement">View More</a>}
                                        </div>
                                    </div>
                                    {this.state.selected_list === "matched" && <div className="mybet-alldata bg-white table-responsive">
                                        <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                            <thead>
                                                <tr className="bg-dark text-white">
                                                    <th>Matched</th>
                                                    <th>Odds</th>
                                                    <th>Stake</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bet_list.map((bet, i) => {
                                                    return (
                                                        <>
                                                            {i < this.state.betLimitMobile && <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                                <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                                <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                                <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                            </tr>}
                                                        </>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>}
                                    {this.state.selected_list === "unmatched" && <div className="mybet-alldata bg-white table-responsive">
                                        <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                            <thead>
                                                <tr className="bg-dark text-white">
                                                    <th>Matched Bet</th>
                                                    <th>Odds</th>
                                                    <th>Stake</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.unmatched_bet.map((bet) => {
                                                    return (
                                                        <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                            <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                            <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                            <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>{/* <td><img alt="" style={{ marginLeft: "38%" }} src={require('../images/close.png')} /></td> *}
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>}
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <div className={`col-right ${(!!accData && Object.keys(accData).length > 0) ? '' : 'col-right-login'}`}>
                        <div className="sub_path over-wrap">
                            {!!this.state.tvUrl && this.state.tvUrl !== "" && (!!prfdt && prfdt.role !== "DemoClient") && <><div className="center-box mb-1 inline">
                                <p>Live TV
                                    <div className="custom-control custom-switch float-right" style={{ display: "inline" }} onMouseDown={() => { this.liveTvToggle() }}>
                                        <input type="checkbox" className="custom-control-input" checked={this.state.tvShow} />
                                        <label className="custom-control-label" for="customSwitches"></label>
                                    </div>
                                </p>
                            </div>
                                {!!this.state.tvShow && !!this.state.isDesktop && <div className="mb-0 tviframe">
                                    {!(!!this.state.canSeeTVMSG) && this.state.canSeeTVCheck ? <iframe title={"iframe mobile"} key={"iframe_mob"} id='fp_embed_player' src={!!this.state.streamName ? this.state.streamName : this.state.tvUrl} marginWidth='0' marginHeight='0' frameBorder='0' width='100%' height='100%' scrolling='no' allowFullScreen='allowfullscreen'></iframe> :
                                        <div className='no-balence'>{this.state.canSeeTVMSG}</div>
                                    }
                                </div>}</>}
                            <div className="center-box">
                                <div className="container-fluid titbg">
                                    <div className="w-100 float-left">
                                        <span onClick={() => { this.setState({ selected_list: "matched" }) }} className={this.state.selected_list === "matched" ? "betslip-btn active" : "betslip-btn"}>Matched Bet</span>
                                        {bet_list.length > this.state.betLimit && <a className="view-more-btn" onClick={() => { this.setState({ betSlipOpen: true }) }} data-toggle="modal" data-target="#mystatement">View More</a>}
                                    </div>
                                </div>
                                {this.state.selected_list === "matched" && <div className="mybet-alldata bg-white table-responsive">
                                    <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                        <thead>
                                            <tr className="bg-dark text-white">
                                                <th>Matched Bet</th>
                                                <th>Odds</th>
                                                <th>Stake</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!!bet_list && bet_list.length > 0 ? 
                                            bet_list.map((bet, i) => {
                                                return (
                                                    <>
                                                        {i < this.state.betLimit && <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                            <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                            <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                            <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                        </tr>}
                                                    </>
                                                )
                                            })
                                            :
                                            <tr>
                                                <td className='text-center text-danger' colSpan={3}>No bets found...</td>
                                            </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>}
                                {this.state.selected_list === "unmatched" && <div className="mybet-alldata bg-white table-responsive">
                                    <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                        <thead>
                                            <tr className="bg-dark text-white">
                                                <th>Matched Bet</th>
                                                <th>Odds</th>
                                                <th>Stake</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.unmatched_bet.map((bet) => {
                                                return (
                                                    <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                        <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                        <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                        <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>}
                            </div>
                        </div>
                    </div>
                    {this.state.showExpo && <ExpoPopup lineExpo={this.state.lineExpo} lineName={this.state.lineName} hidePopup={() => { this.hidePopup() }} />}
                    {this.state.betSlipOpen && <BetSlipPopup bets={bet_list} hidePopup={() => { this.hidePopup() }} />}
                </div>
            </body>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Event);